import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]


import { HierarchyTagStore, HierarchyType } from "shared/types/HierarchyTag";


export default /*#__PURE__*/_defineComponent({
  __name: 'HierarchyTagItem',
  props: {
    tag: {}
  },
  setup(__props: any) {

const textClassByType: Record<HierarchyType, string> = {
  building: "text-gray-100",
  level: "text-gray-700",
  section: "text-gray-700",
  component: "text-gray-700",
};

const bgClassByType: Record<HierarchyType, string> = {
  building: "bg-gray-400",
  level: "bg-gray-300",
  section: "bg-gray-200",
  component: "bg-gray-100",
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['px-2 py-0.5 rounded-md truncate', bgClassByType[_ctx.tag.type], textClassByType[_ctx.tag.type]]),
    title: _ctx.tag.name
  }, _toDisplayString(_ctx.tag.name), 11, _hoisted_1))
}
}

})